@if (!utils.isNullOrEmpty(cellule)) {
  <div>
    <table #table>
      <thead class="decoupageRepas">
      <tr>
        <th [style.width.px]="mp2Svc.drWidthLibelle"
            [style.padding-left.px]="4"
            [title]="'Repas : ' + cellule.libelleRepas.toUpperCase()">

          <!--LIBELLE-->
          <div class="d-flex flex-row cursor" (click)="initItemsMenuDecoupageAndDisplay($event)">
            <span>{{ cellule?.libelleDecoupageRepas | uppercase }}</span>
            @if (!hasToDisplay) {
              <span class="d-flex flex-row mg-l-5">
                {{ cellule.choixMax }} plat
                @if (cellule.choixMax > 1) {
                  <span>s</span>
                }
              </span>
            }
          </div>

        </th>

        @if (displayFamillesGemrcn) {
          <th [style.width.px]="mp2Svc.drWidthFamGemrcn" [style.text-align]="'center'">
            <yo-famnuts-decoupage [cellule]="cellule" />
          </th>
        }

        @if (displayAppellations) {
          <th [style.width.px]="mp2Svc.drWidthAppellations" class="no-overflow"></th>
        }

        @if (displayAllergenes) {
          <th [style.width.px]="mp2Svc.drWidthAllergenes" class="no-overflow"></th>
        }

        @if (displayTauxDePrise) {
          <th [style.width.px]="mp2Svc.drWidthTauxDePrise"
              [style.text-align]="'right'"
              class="no-overflow">
            <yo-taux-de-prise-decoupagerepas [cellule]="cellule" />
          </th>
        }

        @if (displayCoutsUnitaires) {
          <th [style.width.px]="mp2Svc.drWidthCoutsUnitaires"
              [style.text-align]="'right'"
              class="no-overflow">
            <yo-cout-decoupage-portion [cellule]="cellule" />
          </th>
        }

        @if (displayCoutsUnitairesPonderes) {
          <th [style.width.px]="mp2Svc.drWidthCoutsUnitairesPonderes"
              [style.text-align]="'right'"
              class="no-overflow">
            <yo-cout-decoupage-pondere [cellule]="cellule" />
          </th>
        }

        @if (displayAnalyseFinanciere) {
          <th [style.width.px]="mp2Svc.drWidthPrixVente"
              [style.text-align]="'right'"
              class="no-overflow">
            <yo-prix-vente-decoupage [cellule]="cellule" />
          </th>
          <th [style.width.px]="mp2Svc.drWidthWidthMarge"
              [style.text-align]="'right'"
              class="no-overflow">
            <yo-marge-decoupage [cellule]="cellule" />
          </th>
        }

      </tr>
      </thead>

      <tbody
        cdkDropList
        [id]="dropListId()"
        [cdkDropListData]="slots"
        [cdkDropListConnectedTo]="connectedDropLists()"
        (cdkDropListDropped)="onDrop($event)"
        (cdkDropListEntered)="onDragEntered($event)"
        (cdkDropListExited)="onDragExited()"
        (cdkDropListSorted)="onListSorted($event)"
        class="font-12"
        [class.hovering-occupied]="hoveringOccupied"
        [style.display]="hasToDisplay ? '' : 'none'">

        @for (slot of slots; track slot.idxSlot) {

          <tr
            cdkDrag
            [cdkDragDisabled]="!isDragEnabled()
              || (cellule.nonModifiable &amp;&amp; !isCopyMode())
              || utils.isNullOrEmpty(getMenuComposition(cellule, slot.idxSlot))"
            [cdkDragData]="{ menuComposition: getMenuComposition(cellule, slot.idxSlot), cellule: cellule }"
            [class.non-modifiable]="cellule.nonModifiable"
            class="tr-menucompo"
            [class.duplication-recopie-forcee]="!utils.isCollectionNullOrEmpty(getMenuComposition(cellule, slot.idxSlot)?.menuCompositionRecopieList)">

            <!-- Preview drag -->
            <ng-template cdkDragPreview>
              <div class="drag-preview">
                {{ getMenuComposition(cellule, slot.idxSlot)?.produitDeclinaisonLibelle }}
              </div>
            </ng-template>

            <!-- Placeholder -->
            <ng-template cdkDragPlaceholder>
              <tr class="drag-placeholder">
                <td [attr.colspan]="getColspan()">↓ Déposer ici</td>
              </tr>
            </ng-template>

            @if (!utils.isNullOrEmpty(getMenuComposition(cellule, slot.idxSlot))) {

              @let menuComposition = getMenuComposition(cellule, slot.idxSlot);

              <td [style.width.px]="mp2Svc.drWidthLibelle"
                  [style.padding-left.px]="6"
                  class="no-overflow"
                  (click)="initItemsMenuCompositionAndDisplay($event, cellule, menuComposition, slot.idxSlot)">

        <p-menu #menuMenuComposition appendTo="body" [popup]="true" [model]="itemsMenuComposition" styleClass="context-menu"></p-menu>

                <span>
                  @if (menuComposition.dishWithoutFavouritesItems) {
                    <i class="width-25 fas fa-exclamation-triangle text-warning cursor"
                       id="warning-{{menuComposition.id}}"
                       title="Le plat dispose d'une denrée inactive ou sans article préféré actif"></i>
                  }
                  @if (menuComposition.horsSaisonnalite) {
                    <i class="fas fa-calendar danger-color" title="Plat hors saison"></i>
                  }
                  @if (menuComposition.delaiCommandeSpecifique) {
                    <i class="fas fa-business-time danger-color" title="Article avec Délai de commande spécifique"></i>
                  }
                  @if (menuComposition.appellationOrAllergeneModified) {
                    <i class="fas fa-pen-square" title="Allergènes ou appellations modifiés"></i>
                  }
                  {{ menuComposition.produitDeclinaisonLibelle }}
                </span>
              </td>

              @if (displayFamillesGemrcn) {
                <td [style.text-align]="'center'" [style.width.px]="mp2Svc.drWidthFamGemrcn" class="no-overflow">
                  <yo-famnuts-menucompo [famillesNutritionnellesProduits]="menuComposition.familleNutritionnelleProduitDTOList" />
                </td>
              }
              @if (displayAppellations) {
                <td [style.width.px]="mp2Svc.drWidthAppellations" [style.text-align]="'center'" class="no-overflow">
                  <yo-appellations-menucompo [produitAppellations]="menuComposition.produitAppellationDTOList" />
                </td>
              }
              @if (displayAllergenes) {
                <td [style.text-align]="'center'" [style.width.px]="mp2Svc.drWidthAllergenes" class="no-overflow">
                  <yo-allergenes-menucompo [produitsAllergenes]="menuComposition.produitAllergeneDTOList" />
                </td>
              }
              @if (displayTauxDePrise) {
                <td [style.width.px]="mp2Svc.drWidthTauxDePrise" [style.text-align]="'right'" class="no-overflow">
                  <yo-taux-de-prise-menucompo
                    [disable]="isDisabled(cellule.contratMenuSiteId, cellule.nonModifiable)"
                    [menuCompo]="menuComposition"
                    [cellule]="cellule" />
                </td>
              }
              @if (displayCoutsUnitaires) {
                <td [style.width.px]="mp2Svc.drWidthCoutsUnitaires" [style.text-align]="'right'" class="no-overflow">
                  <yo-cout-portion [menuComposition]="menuComposition" />
                </td>
              }
              @if (displayCoutsUnitairesPonderes) {
                <td [style.width.px]="mp2Svc.drWidthCoutsUnitairesPonderes" [style.text-align]="'right'" class="no-overflow">
                  <yo-cout-portion-pondere [menuCompo]="menuComposition" />
                </td>
              }
              @if (displayAnalyseFinanciere) {
                <td [style.width.px]="mp2Svc.drWidthPrixVente" [style.text-align]="'right'" class="no-overflow">
                  <yo-prix-de-vente [menuCompo]="menuComposition" />
                </td>
                <td [style.width.px]="mp2Svc.drWidthWidthMarge" [style.text-align]="'right'" class="no-overflow">
                  <yo-marge [menuCompo]="menuComposition" />
                </td>
              }

            } @else {
              @if (!cellule.nonModifiable) {
                <td [style.width.%]="100" [attr.colspan]="getColspan()">
                  <div (click)="showDialogRecherchePlats(cellule)">
                    <label class="menucomposition-label mg-r-5"></label>
                  </div>
                </td>
              }
            }
          </tr>
        }
      </tbody>
    </table>
  </div>
}

<!--SOUS MENU DE SELECTION-->
<p-menu #menuDecoupage appendTo="body" [popup]="true" [model]="itemsMenuDecoupage" />
<div #emptyDiv></div>
